/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QuotesResponseGetRecordsList } from '../../models/quotes-response-get-records-list';

export interface QuotesControllerGetQuotes$Params {

/**
 * A required project id for which the quotes were created.
 */
  projectId: string;

/**
 * A required variant id, which plannings quotes will be returned.
 */
  variantId: string;
}

export function quotesControllerGetQuotes(http: HttpClient, rootUrl: string, params: QuotesControllerGetQuotes$Params, context?: HttpContext): Observable<StrictHttpResponse<QuotesResponseGetRecordsList>> {
  const rb = new RequestBuilder(rootUrl, quotesControllerGetQuotes.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('variantId', params.variantId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QuotesResponseGetRecordsList>;
    })
  );
}

quotesControllerGetQuotes.PATH = '/planning-projects/v1-develop/quotes';
